// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getUsers } from "./get-users.action";
import { getUsersSeoContent } from "./get-users-seo-content.action";

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	success: false,
	error: false,
	data: [],
	location: {
		country: null,
		region: null,
		city: null,
	},
	location_search: {
		country: null,
		countries: null,
		region: null,
		regions: null,
		city: null,
		cities: null,
	},
	pagination: {
		currentpage: 0,
		totalpages: 0,
	},
	findnumber: 0,
	fromServer: false,
	locationMd5Hash: "",
	seoContent: {
		loading: false,
		loaded: false,
		success: false,
		error: false,
		data: [],
	},
};

// ############################################################

// Slice
const mainPageUsersSlice = createSlice({
	name: "mainPages/users",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// getUsers
			.addCase(getUsers.pending, (state, action) => {
				const isInfinityScroll = action.meta.infinityScroll;
				state.loading = true;

				if (!isInfinityScroll) {
					state.data = [];
					state.seoContent.data = [];
					state.seoContent.loaded = false;
					state.seoContent.loading = false;
					state.seoContent.success = false;
					state.seoContent.error = false;
					state.pagination = {
						currentpage: 1,
						totalpages: 1,
					};
					state.location = {
						country: null,
						region: null,
						city: null,
					};
					state.location_search = {
						country: null,
						countries: null,
						region: null,
						regions: null,
						city: null,
						cities: null,
					};
				}
			})
			.addCase(getUsers.fulfilled, (state, action) => {
				state.loading = false;
				state.loaded = true;
				state.success = true;
				state.error = false;

				if (action.payload.infinityScroll) {
					const newDataUsers = [
						...state.data,
						...(action.payload.data?.users ?? []),
					];

					const newDataUsersFiltered = newDataUsers.filter(
						(val, id) => {
							return (
								id ===
								newDataUsers.findIndex((el) => el.id === val.id)
							);
						}
					);

					state.data = newDataUsersFiltered;
				} else {
					state.data = action.payload.data?.users ?? [];
				}
				state.location = {
					country: action.payload.data?.location?.country,
					countryId:
						action.payload.data?.location_search?.country?.id ||
						null,
					region: action.payload.data?.location?.region,
					city: action.payload.data?.location?.city,
				};

				state.location_search = {
					country: action.payload.data?.location_search?.country,
					countries: action.payload.data?.location_search?.countries,
					region: action.payload.data?.location_search?.region,
					regions: action.payload.data?.location_search?.regions,
					city: action.payload.data?.location_search?.city,
					cities: action.payload.data?.location_search?.cities,
				};

				state.pagination = {
					currentpage:
						action.payload.data?.pagination.currentpage ?? 1,
					totalpages: action.payload.data?.pagination.totalpages ?? 1,
				};

				state.findnumber = action.payload.data?.total ?? 0;
				state.fromServer = action.payload.fromServer;
				state.locationMd5Hash = action.payload.locationMd5Hash;
			})
			.addCase(getUsers.rejected, (state) => {
				state.loading = false;
				state.loaded = true;
				state.success = false;
				state.error = true;
			})
			// getUsersSeoContent
			.addCase(getUsersSeoContent.pending, (state) => {
				state.seoContent.loading = true;
				state.seoContent.data = [];
			})
			.addCase(getUsersSeoContent.fulfilled, (state, action) => {
				state.seoContent.loading = false;
				state.seoContent.loaded = true;
				state.seoContent.success = true;
				state.seoContent.error = false;
				state.seoContent.data = action.payload.data;
			})
			.addCase(getUsersSeoContent.rejected, (state) => {
				state.seoContent.loading = false;
				state.seoContent.loaded = true;
				state.seoContent.success = false;
				state.seoContent.error = true;
			});
	},
});

// ############################################################

export default mainPageUsersSlice.reducer;

// ############################################################
